"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.rag.name': 'Base di Conoscenza',
    'tools.rag.description': 'Cerca e recupera informazioni rilevanti dai documenti della base di conoscenza',
};
